import { CompetitionsMenuSchema } from '@/views/sports/components/CompetitionsMenu/styles/CompetitionsMenu.styles';

export const competitionsMenuStyles: CompetitionsMenuSchema = {
  accordion: {
    minW: '190px',
    mr: '3',
    height: 'fit-content',
    py: '3px',
    px: '1px',
    borderRadius: 'md',
    overflow: 'hidden',
    bg: '#6141B7',
    boxShadow: '0px 0px 0px 1px #FFFFFF1F inset, 0px 4px 10px 0px #0000004D',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    mx: '0.5',
    _first: {
      borderTopRadius: 'md',
    },
    _last: {
      mb: '0',
      borderBottomRadius: 'md',
    },
    pos: 'relative',
    _notFirst: {
      borderTopColor: 'rgba(0, 0, 0, 0.25)',
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
    },
    _before: {
      border: 'inherit',
      borderColor: 'rgba(255, 255, 255, 0.1)',
      content: '""',
      h: '1px',
      left: '0',
      pos: 'absolute',
      right: '0',
      top: '0',
    },
  },
  accordionButton: {
    pl: '3',
    pr: '2',
  },
  accordionHeadingText: {
    flex: '1',
    textAlign: 'left',
    fontWeight: 'bold',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
    fontFamily: 'accent',
    letterSpacing: '1px',
    fontSize: 'xs',
    textTransform: 'uppercase',
  },
  accordionIcon: {
    sx: {
      color: 'gamma.400',
    },
  },
  accordionPanel: {
    p: '0',
    fontSize: 'xs',
  },
};
